import React, { forwardRef, useEffect, useState } from 'react';
import { CotinFooter } from '@cotin/biblioteca-componentes-react';
import {
    getFooterLogoPath,
} from '@/core/configs/brand-logos.config';
import {
    obterConfiguracoesSistema,
    subscribeBrasaoOficial,
} from '@/services/configuracoes-sistema.service';

const Footer = forwardRef<HTMLDivElement>((_, ref) => {
    const currentYear = new Date().getFullYear();
    const [footerLogoSrc, setFooterLogoSrc] = useState(getFooterLogoPath(false));

    useEffect(() => {
        void obterConfiguracoesSistema();
        return subscribeBrasaoOficial((brasaoOficial) => {
            setFooterLogoSrc(getFooterLogoPath(brasaoOficial));
        });
    }, []);

    return (
        <div className="footer" ref={ref}>
            <CotinFooter
                logoSrc={footerLogoSrc}
                logoAlt="COTIN"
                text={`${currentYear} COTIN - Todos os direitos reservados`}
            />
        </div>
    );
});

Footer.displayName = 'Footer';

export default Footer;
